import { all, call } from 'redux-saga/effects';
import { runGaBlockImpressionDetector } from './ga-blockimpression.pdp';
import { runGaClickButtonDetector } from './ga-clickbutton.pdp';
import { runGaFocusDetector } from './ga-focus.pdp';

export function* runReviewsGaDetectors() {
  yield all([call(runGaBlockImpressionDetector), call(runGaClickButtonDetector), call(runGaFocusDetector)]);
}
